export const getUpdatedIdea = (idea, currentTab, type, initialState) => {
  switch (currentTab) {
    case 0: {
      const descriptionField = ["eureka", "contradiction"].includes(type) ? "description" : "comment";
      const nameField = ["eureka", "contradiction"].includes(type) ? "name" : "ideaName";

      return {
        ...idea,
        [descriptionField]: "",
        [nameField]: "",
        image: { name: "", originalName: "", id: "" },
        imagesLibrary: [],
      };
    }
    case 1: {
      const customBenefits = {
        contradiction: "potentialBenefitsOfContradictionSolving",
        eureka: "potentialBenefitsOfEureka",
        multiplication: "potentialBenefitsOfMultiplication",
        subtraction: "potentialBenefitsOfSubtraction",
        replacement: "potentialBenefitsOfReplacement",
        dependency: "benefits",
      };

      return {
        ...idea,
        score: null,
        [customBenefits[type]]: [{ name: "", description: "", target: [], userInfo: "" }],
      };
    }
    case 2: {
      return {
        ...idea,
        issues: [{ comment: "", description: "", createdByUser: "" }],
        issuesMessages: [],
        feasibleScore: null,
        isIdeaFeasible: null,
      };
    }

    default: {
      return initialState;
    }
  }
};
